import React, {useState, useEffect, useRef, useMemo} from "react";
import PropTypes from "prop-types";
import { richTextFromMarkdown } from "@contentful/rich-text-from-markdown";
import CustomRichText from "./CustomRichText";

const CustomRichTextFromMarkdown = ({markdownString, fallback}) => {

    const mountedRef = useRef(true);
    const [document, setDocument] = useState(false);

    const doRichText = useMemo(() => (markdownString, fallback) => {
        return richTextFromMarkdown(markdownString, fallback).then(data => {
            if (!mountedRef.current) {
                return null;
            }
            setDocument(data);
            return data;
        });
    }, [richTextFromMarkdown, setDocument]);

    useEffect(() => {
        doRichText(markdownString, fallback);
    }, [markdownString, doRichText]);

    useEffect(() => {
        return () => {
            mountedRef.current = false;
        };
    }, [mountedRef]);

    return (
        <>
            {document && <CustomRichText document={document}/>}
        </>
    );

};

CustomRichTextFromMarkdown.propTypes = {
    markdownString: PropTypes.string.isRequired,
    fallback: PropTypes.func
};

export default CustomRichTextFromMarkdown;
